/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileSmall } from "./_background/background-file-small.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileGamingSmall = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--small",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "small" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 40,
      height: 40,
      className: cls,
      "data-testid": "FileGamingSmall",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileSmall, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M16.92 9.553c-.397.397-.397.782 0 1.179.396.396.781.396 1.178 0 .396-.397.396-.782 0-1.179-.397-.396-.782-.396-1.179 0Zm-2.947.59c-.397.396-.397.781 0 1.178.396.396.782.396 1.178 0 .397-.396.397-.782 0-1.178-.396-.397-.782-.397-1.178 0ZM9.259 16.33l-.737-.737.884-.884.737.737.736-.737.884.884-.736.737.736.736-.884.884-.736-.736-.737.736-.884-.884.737-.736Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.995 8.227a1.042 1.042 0 0 1 0-1.473l.59-.589-.884-.884-.59.59a2.292 2.292 0 0 0 0 3.24l.442.442a1.042 1.042 0 0 1 0 1.473l-2.357 2.357c-1.982 1.983-1.982 3.91 0 5.893 1.983 1.983 3.91 1.983 5.893 0 1.406-1.406 1.815-2.784 1.227-4.173l.787-.787c1.39.587 2.767.178 4.173-1.227 1.983-1.983 1.983-3.91 0-5.893-1.982-1.982-3.91-1.982-5.892 0l-2.387 2.387a2.282 2.282 0 0 0-.56-.914l-.442-.442Zm-1.915 6.04c-.861.862-1.12 1.54-1.12 2.063 0 .523.259 1.2 1.12 2.062.862.861 1.54 1.12 2.063 1.12.522 0 1.2-.259 2.062-1.12.609-.609.919-1.13 1.046-1.562.119-.404.1-.8-.086-1.24l-.328-.776 1.977-1.978.776.329c.44.186.836.205 1.24.086.432-.127.953-.437 1.562-1.046.862-.861 1.121-1.54 1.121-2.063 0-.522-.26-1.2-1.12-2.062-.862-.861-1.54-1.12-2.063-1.12-.523 0-1.201.259-2.062 1.12L8.08 14.267Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M9.72 7.74c.044.179.136.348.275.487l.442.442c.266.266.452.58.56.914l2.387-2.387c1.982-1.982 3.91-1.982 5.892 0 1.076 1.076 1.568 2.135 1.476 3.196-.077-.895-.569-1.79-1.476-2.697-1.982-1.982-3.91-1.982-5.892 0l-2.387 2.386a2.282 2.282 0 0 0-.56-.913l-.442-.442a1.041 1.041 0 0 1-.275-.986Zm.615-1.326.25-.249-.884-.884-.59.59a2.287 2.287 0 0 0-.657 1.87c.054-.502.273-.988.657-1.372l.59-.589.634.634Zm4.113 9.056-.132.131c.138.327.221.652.25.978.031-.37-.008-.74-.118-1.11ZM5.72 16.58c.077-.895.57-1.79 1.476-2.698l2.357-2.357c.268-.267.36-.644.275-.986a1.037 1.037 0 0 1-.275.487l-2.357 2.357C6.121 14.46 5.63 15.518 5.72 16.58Zm1.259 0c-.014.086-.02.169-.02.248 0 .523.26 1.202 1.121 2.063.862.861 1.54 1.12 2.063 1.12.522 0 1.2-.259 2.062-1.12.609-.609.919-1.13 1.046-1.562.073-.25.094-.495.056-.75a1.859 1.859 0 0 1-.056.25c-.127.432-.437.954-1.046 1.563-.861.861-1.54 1.12-2.062 1.12-.523 0-1.201-.259-2.063-1.12-.73-.73-1.028-1.329-1.101-1.813Zm6.006-1.415-.148-.35 1.977-1.979.776.329c.44.186.836.205 1.24.086.432-.127.953-.437 1.562-1.046.73-.73 1.028-1.33 1.102-1.813.013.087.02.17.02.25 0 .522-.26 1.2-1.122 2.062-.609.609-1.13.918-1.562 1.046-.404.119-.8.1-1.24-.087l-.776-.328-1.829 1.83Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M16.675 10.392c-.12-.28-.038-.556.244-.839.397-.396.782-.396 1.179 0 .282.283.363.56.243.839a1.115 1.115 0 0 0-.243-.34c-.397-.396-.782-.396-1.179 0a1.115 1.115 0 0 0-.244.34Zm-2.945.589c-.12-.28-.04-.556.243-.838.396-.397.782-.397 1.178 0 .283.282.364.559.244.838a1.115 1.115 0 0 0-.244-.34c-.396-.396-.782-.396-1.178 0a1.115 1.115 0 0 0-.244.34Zm-4.958 4.861-.25-.249.884-.884.737.737.736-.737.884.884-.25.25-.634-.635-.736.737-.737-.737-.634.634Zm.238.738-.488.486.25.25.487-.488-.25-.249Zm2.504.736.25-.25-.488-.487-.25.25.488.487Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FileGamingSmall
};
